import BookDemoForm, { getServerSidePropsFunc } from '../bookafreehomedemo';
export default BookDemoForm;
export const getServerSideProps = getServerSidePropsFunc('/aquaguard/book-a-demo');
